<template>
  <div class="team-pulse-card team-pulse-legend p-x2">
    <div class="f-v f-gap-16">
      <!-- Participation -->
      <div class="f-v">
        <div class="t-lg bold m-bx1">Participation</div>
        <div class="t-sm dark-gray m-bx2">How actively people contribute to the conversation, based on message frequency, responsiveness to others, and overall interaction patterns.</div>
        <div class="f f-h">
          <div
            v-for="i in 4"
            :key="i"
            class="participation-bar-container"
          >
            <cdn-svg
              :path="`nucleo/meter-bars-${i}`"
              :version="0"
              class="h-x4 w-x5"
            />
          </div>
        </div>
      </div>

      <!-- Sentiment -->
      <div class="f-v">
        <div class="t-lg bold m-bx1">Sentiment</div>
        <div class="t-sm dark-gray m-bx2">The emotional tone of the chat</div>
        <div class="f f-h f-gap-5">
          <cdn-svg
            v-for="i in 5"
            :key="i"
            :path="`nucleo/sentiment-face-${i}`"
            :version="0"
            class="h-x4 w-x4"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
</script>

<style scoped lang="scss">
@import '../../styles/donut';

.team-pulse-card {
  border: none;
  border-radius: 12px;
  box-shadow: none;
  display: flex;
  flex-direction: column;
}

.team-pulse-legend {
  flex: 1;
  min-width: 200px;
  max-width: 300px;
  background-color: $lightest-gray;
}
</style>

